<div class="wrapper">
    @if (buildingsDatasource) {
        <div class="grid">
            <app-server-side-grid
                [colDefs]="gridColumns"
                [datasource]="buildingsDatasource"
                [noRows]="noResults()"
                [titleNoData]="'No Buildings available.'"
            ></app-server-side-grid>
        </div>
    }
</div>
